import React from "react";
import PropTypes from "prop-types";
import "./HeroSection.css"; // Ensure you have a CSS file for styling

const HeroSection = ({ backgroundImage, title, subtitle, children }) => {
  return (
    <div
      className="hero-section"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="hero-overlay">
        <div className="hero-content">
          {title && <h1 className="hero-title">{title}</h1>}
          {subtitle && <p className="hero-subtitle" >{subtitle}</p>}
          {children}
        </div>
      </div>
    </div>
  );
};

HeroSection.propTypes = {
  backgroundImage: PropTypes.string.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node,
};

export default HeroSection;
